import {
   rand,
   randNumber,
   randFloat,
   randRecentDate,
   randSentence,
   randParagraph,
   randProductName,
   randAirportCode,
   randCatchPhrase,
} from '@ngneat/falso';
import { optional } from '@library/common/functions';

import {
   MockHawb,
   MockBillingParty,
   MockReference,
   MockTradeshow,
   MockCOD,
   MockPOD,
   MockRisks,
} from '@library/common/models/mock';

import {
   Invoice,
   InvoiceTypes,
   InvoiceHawb,
   InvoiceHeader,
   Charge,
   InvoiceCalculator,
} from './invoice';

export class MockInvoice {
   id = randNumber();

   attached = [];

   type = rand( Object.keys( InvoiceTypes ));

   account = randNumber();
   terms = 'Net 30';

   invoicedate = randRecentDate({ days: 10 });
   duedate = randRecentDate({ days: 10 });

   total = +randFloat();
   currency = 'USD';

   station = new MockBillingParty();

   notes = optional() ? randSentence() : '';

   hawb = MockHawb();
   servicelevel = randProductName();

   pickupdate = randRecentDate({ days: 10 });

   totalpieces = randNumber();
   actualweightlbs = randNumber();
   actualweightkgs = randNumber();
   volumeweightlbs = randNumber();
   volumeweightkgs = randNumber();
   chargeableweightlbs = randNumber();
   chargeableweightkgs = randNumber();

   bill_to = new MockBillingParty();
   shipper = new MockBillingParty();
   consignee = new MockBillingParty();

   origin = optional() ? randAirportCode() : undefined;
   destination = optional() ? randAirportCode() : undefined;

   calculator = optional() ? Array.from({ length: randNumber({ max: 5 }) + 1 }, _ => new MockInvoiceCalculator() ) : undefined;
   charges = Array.from({ length: randNumber({ max: 20 }) + 1 }, _ => new MockCharge() );

   references = optional() ? Array.from({ length: randNumber({ max: 10 }) + 1 }, _ => new MockReference() ) : undefined;
   tradeshow = optional() ? [ new MockTradeshow( 'from' ), new MockTradeshow( 'to' ) ] : undefined;

   cod = optional() ? new MockCOD() : undefined;
   pod = optional() ? new MockPOD() : undefined;
   risks = optional() ? new MockRisks() : undefined;

   description = optional() ? randParagraph() : undefined;

   shipmentAccess = optional() ? true : false;
}

export class MockActualInvoice extends Invoice {
   constructor() {
      super({
         id: randNumber(),
         type: rand( Object.keys( InvoiceTypes )),
         account: randNumber(),
         terms: 'Net 30',
         invoicedate: randRecentDate({ days: 10 }),
         duedate: randRecentDate({ days: 10 }),
         total: randFloat(),
         currency: 'USD',
         station: new MockBillingParty(),
         notes: randSentence(),
         attached: Array.from({ length: randNumber({ max: 10 }) + 1 }, _ => new MockInvoiceHawb() ),
      });
   }
}

export class MockInvoiceHawb extends InvoiceHawb {
   constructor() {
      super();

      this.hawb = MockHawb();
      this.servicelevel = randProductName();

      this.total = +randFloat();
      this.currency = 'USD';

      this.invoicedate = randRecentDate({ days: 10 });
      this.pickupdate = randRecentDate({ days: 10 });

      this.totalpieces = randNumber();
      this.actualweightlbs = randNumber();
      this.actualweightkgs = randNumber();
      this.volumeweightlbs = randNumber();
      this.volumeweightkgs = randNumber();
      this.chargeableweightlbs = randNumber();
      this.chargeableweightkgs = randNumber();

      this.bill_to = new MockBillingParty();
      this.shipper = new MockBillingParty();
      this.consignee = new MockBillingParty();

      this.origin = randAirportCode();
      this.destination = randAirportCode();

      this.calculator = Array.from({ length: randNumber({ max: 5 }) + 1 }, _ => new MockInvoiceCalculator() );
      this.charges = Array.from({ length: randNumber({ max: 20 }) + 1 }, _ => new MockCharge() );

      this.references = Array.from({ length: randNumber({ max: 10 }) + 1 }, _ => new MockReference() );
      this.tradeshow = [ new MockTradeshow( 'from' ), new MockTradeshow( 'to' ) ];

      this.cod = new MockCOD();
      this.pod = new MockPOD();
      this.risks = new MockRisks();

      this.description = randParagraph();
      this.notes = randSentence();

      this.shipmentAccess = false;
   }
}

export class MockInvoiceHeader extends InvoiceHeader {
   constructor() {
      const type = rand( Object.keys( InvoiceTypes ));

      super({
         id: randNumber(),
         consignee: new MockBillingParty(),
         invoicedate: randRecentDate({ days: 90 }),
         type,
         total: ( type === 'credit' ? -1 : 1 ) * ( +randFloat()) * (( Math.random() > 0.9 ) ? 100 : 1 ),
         currency: rand([ 'USD', 'CAD', 'EUR' ]),
         // currency: 'USD',
      });
   }
}

export class MockCharge extends Charge {
   constructor() {
      super({
         description: randCatchPhrase(),
         quantity: randNumber(),
         rate: randNumber(),
         amount: +randFloat(),
         // currency: rand([ 'USD', 'CAD', 'JPY', 'EUR', 'GRP' ]),
         currency: 'USD',
      });
   }
}

export class MockInvoiceCalculator extends InvoiceCalculator {
   constructor() {
      super({
         item:  randNumber({ max: 20 }),
         itemType:  rand([ 'CARG' ]),

         pieces:  randNumber({ max: 100 }),
         piecesType:  rand([ 'PC', 'PAL', 'CRT' ]),

         length:  randNumber({ max: 50 }),
         width:  randNumber({ max: 50 }),
         height:  randNumber({ max: 50 }),
         dimsType:  rand([ 'ft', 'in' ]),

         weight:  randNumber({ max: 200 }),
         weightType:  rand([ 'lbs', 'kgs' ]),

         cubicFt:  randNumber({ max: 200 }),
         cubicM:  randNumber({ max: 200 }),

         marks:  randCatchPhrase(),
      });
   }
}
